module.exports = __webpack_public_path__ + "img/ic24Time.c1b49403.svg";